import styled from '@emotion/styled';

const ThumbButton = styled('button')(({ theme }) => ({
  '&:hover': {
    opacity: 1,
  },

  backgroundColor: theme.colors.transparent.primary,
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  opacity: 0.8,
  outline: 'none',
}));

export default ThumbButton;
